import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from '../Login.module.scss';
import usePostRenewAccount from '../../../hooks/useApi/usePostRenewAccount';
import { useTranslation } from 'react-i18next';

const { Icon, Box, Title } = vp;

type FC = FunctionComponent;

const AccountRenewal: FC = () => {
  const { Token } = useParams<{ Token: string }>();
  const [responsePostRenewAccount, postRenewAccount] = usePostRenewAccount({});
  const [isReady, setIsReady] = useState(false);
  const [isRenew, setIsRenew] = useState(false);
  const { t } = useTranslation('translations', { keyPrefix: 'Login.AccountRenewal' });

  useEffect(() => {
    setIsRenew(true);
    postRenewAccount({
      Token,
    });
  }, []);
  useEffect(() => {
    if (isRenew) {
      setIsReady(true);
    }
  }, [responsePostRenewAccount]);

  return (
    <>
      <Box flx="col">
        <Box mb="sm" flx="col" ai="center" height="auto">
          <Title title={t('title')} bold size="xsm" />
        </Box>
        {isReady && (
          <Box mb="sm" flx="col" ai="center" height="auto">
            {responsePostRenewAccount.Success && <Icon icon="check" size="jumbo" />}
            {!responsePostRenewAccount.Success && <Icon icon="error" size="jumbo" />}
          </Box>
        )}
        <div className={styles.errorText}>
          {responsePostRenewAccount.Success && t('successMessage')}
          {!responsePostRenewAccount.Success && <>{responsePostRenewAccount.ErrorMessage}</>}
        </div>
      </Box>
    </>
  );
};

export default AccountRenewal;
